import { ErrorVisualMode } from '@ui-components/containers/ErrorComponentTypes'
import { SimpleStep } from '@ui-components/layout/SimpleStep'
import { PrimaryTopBarActionButtonOptions } from '@ui-components/navigation/PrimaryTopBar/types'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { TransitionErrorIndicator } from '../../components/TransitionErrorIndicator'
import { useSendPageViewEvent } from '../../hooks/useSendPageViewEvent'
import { useCommonAnalyticsContext } from '../../state/AnalyticsContext'

interface AuthenticationCancelledStepProps {
  onRetry: () => void
  onAbort: () => void
}

export const AuthenticationCancelledStep = ({ onRetry, onAbort }: AuthenticationCancelledStepProps): JSX.Element => {
  const intl = useIntl()

  const actionButtonOptions: PrimaryTopBarActionButtonOptions = {
    label: intl.formatMessage({ id: 'common-exit' }),
    onClick: () => {
      analyticsService.sendCustomEvent('AuthenticationCancelledByUser', 'AbortButton')
      onAbort()
    },
  }
  const { analyticsService } = useCommonAnalyticsContext()

  useSendPageViewEvent(analyticsService, 'AuthenticationCancelledByUser')

  return (
    <SimpleStep actionButtonOptions={actionButtonOptions}>
      <TransitionErrorIndicator
        action={{
          onClick: () => {
            analyticsService.sendCustomEvent('AuthenticationCancelledByUser', 'RetryButton')
            onRetry()
          },
          label: intl.formatMessage({ id: 'common-retry' }),
        }}
        heading={intl.formatMessage({ id: 'common-authentication-cancelled-heading' })}
        text={intl.formatMessage({ id: 'common-authentication-cancelled-text' })}
        mode={ErrorVisualMode.Plain}
      />
    </SimpleStep>
  )
}
